function Footer(){
    return(
        <>
    {/* <!--------------------Footer ----------------------------> */}
    <footer>
        <div className="haye">
            <div className="ff">
                <p><i className="fa-solid fa-code"></i> Designed And Devaloped By </p>
                <a className="ff_a" href="https://wa.link/4fkyt8" target="_blank"> Eng Jumhuur</a>
            </div>
        </div>
    </footer>
        </>
    )
}


export default Footer